import { RootState } from 'store';

// Selectors, performing common selection tasks for this slice.
export const selectUserAppointments = ({ appointments }: RootState) => appointments.userAppointments.rows;
export const selectUserAppointmentsTotal = ({ appointments }: RootState) => appointments.userAppointments.total;
